export default "__VITE_ASSET__CwYECKMr__"